import React from "react";

const specialties = [
  {
    title: "Skin Care",
    description:
      "Expert treatment for various skin conditions including acne, eczema, psoriasis, and other dermatological issues",
    icon: "https://cdn-icons-png.flaticon.com/512/375/375279.png",
  },
  {
    title: "Hair Treatment",
    description:
      "Comprehensive solutions for hair loss, dandruff, premature greying, and other scalp-related issues",
    icon: "https://cdn-icons-png.flaticon.com/512/375/375279.png",
  },
  {
    title: "Pediatric Care",
    description:
      "Specialized treatment for children's health issues, including developmental concerns and common ailments",
    icon: "https://cdn-icons-png.flaticon.com/512/375/375279.png",
  },
  {
    title: "Chronic Diseases",
    description:
      "Management and treatment of long-term health conditions with holistic approaches",
    icon: "https://cdn-icons-png.flaticon.com/512/375/375279.png",
  },
  {
    title: "Women's Health",
    description:
      "Specialized care for women's health issues including hormonal imbalances and reproductive health",
    icon: "https://cdn-icons-png.flaticon.com/512/375/375279.png",
  },
  {
    title: "Mental Health",
    description:
      "Support and treatment for anxiety, depression, stress, and other mental health concerns",
    icon: "https://cdn-icons-png.flaticon.com/512/375/375279.png",
  },
];

const Specialist = () => {
  return (
    <section id="specialties" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16 animate__animated animate__fadeInUp">
          <h2 className="text-3xl md:text-4xl font-bold text-neutral-900 mb-4 font-poppins">
            Our Specialties
          </h2>
          <p className="text-neutral-600 max-w-2xl mx-auto font-poppins">
            Comprehensive homeopathic treatment for various health conditions
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {specialties.map((specialty, index) => (
            <div
              key={specialty.title}
              className="group relative overflow-hidden rounded-xl animate__animated animate__fadeInUp"
              style={{ animationDelay: `${index * 0.2}s` }}
            >
              <div className="bg-emerald-50 p-6 rounded-xl transition-all duration-300 hover:shadow-xl border border-emerald-100">
                <div className=" flex flex-row space-x-4">
                  <div>
                    <div className="bg-emerald-500/10 rounded-full w-16 h-16 p-3 flex justify-center items-center">
                      <img
                        src={specialty.icon}
                        alt={specialty.title}
                        className="w-8 h-8"
                      />
                    </div>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-neutral-900 mb-2 font-poppins">
                      {specialty.title}
                    </h3>
                    <p className="text-neutral-600 font-poppins">
                      {specialty.description}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12 animate__animated animate__fadeInUp">
          <a
            href="#appointment"
            className="inline-block bg-emerald-500 hover:bg-emerald-600 text-white px-8 py-3 rounded-full transition-colors font-poppins"
          >
            Book a Consultation
          </a>
        </div>
      </div>
    </section>
  );
};

export default Specialist;
